import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { Moon, ShieldCheck, Download, Lock } from 'lucide-react';
export function HeroSection() {
  return <section className="relative bg-navy-950 text-cream-50 pt-20 pb-24 md:pt-32 md:pb-32 overflow-hidden" data-id="element-146">
      {/* Premium subtle background gradient */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-navy-800/40 via-navy-950 to-navy-950 pointer-events-none" data-id="element-147" />

      {/* Subtle moon element */}
      <div className="absolute top-12 right-12 md:top-24 md:right-24 opacity-5" data-id="element-148">
        <Moon size={160} strokeWidth={0.5} data-id="element-149" />
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-150">
        <div className="max-w-5xl mx-auto" data-id="element-151">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-152">
            {/* Text Content */}
            <div className="text-center lg:text-left order-2 lg:order-1" data-id="element-153">
              <FadeIn data-id="element-154">
                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-gold-500/10 border border-gold-500/20 text-gold-400 text-sm font-medium mb-6" data-id="element-155">
                  <Moon size={14} data-id="element-156" />
                  <span data-id="element-157">Guía Digital Práctica</span>
                </div>
                <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold leading-tight mb-6 text-white" data-id="element-158">
                  Recupera noches más tranquilas con un protocolo claro y
                  práctico
                </h1>
              </FadeIn>

              <FadeIn delay={0.1} data-id="element-159">
                <p className="text-lg md:text-xl text-cream-100/80 font-body leading-relaxed mb-8 max-w-2xl mx-auto lg:mx-0" data-id="element-160">
                  Una guía digital diseñada para ayudarte a entender qué activa
                  tu vejiga por la noche, para que puedas descansar con más
                  calma y menos interrupciones.
                </p>
              </FadeIn>

              <FadeIn delay={0.2} data-id="element-161">
                <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 mb-10" data-id="element-162">
                  <Button href="#comprar" className="w-full sm:w-auto text-lg px-8 py-4" data-id="element-163">
                    Quiero acceder a la guía
                  </Button>
                </div>
              </FadeIn>

              <FadeIn delay={0.3} data-id="element-164">
                <div className="flex flex-wrap items-center justify-center lg:justify-start gap-x-6 gap-y-3 text-sm text-cream-100/50 font-medium" data-id="element-165">
                  <div className="flex items-center gap-2" data-id="element-166">
                    <Download size={16} className="text-gold-500/70" data-id="element-167" />
                    <span data-id="element-168">Acceso Inmediato PDF</span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-169">
                    <Lock size={16} className="text-gold-500/70" data-id="element-170" />
                    <span data-id="element-171">Pago Seguro</span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-172">
                    <ShieldCheck size={16} className="text-gold-500/70" data-id="element-173" />
                    <span data-id="element-174">Garantía de Satisfacción</span>
                  </div>
                </div>
              </FadeIn>
            </div>

            {/* Image Content */}
            <div className="order-1 lg:order-2 flex justify-center lg:justify-end relative" data-id="element-175">
              <FadeIn delay={0.2} direction="left" data-id="element-176">
                <div className="relative" data-id="element-177">
                  {/* Soft glow behind image */}
                  <div className="absolute inset-0 bg-gold-500/20 blur-3xl rounded-full transform scale-90" data-id="element-178" />
                  <img src="https://cdn.magicpatterns.com/uploads/eVPGx4bf25Dj1a1Lq4KT22/image_(2).png" alt="Protocolo Próstata: Noches en Paz" className="relative w-full max-w-[400px] lg:max-w-[480px] rounded-2xl shadow-2xl shadow-black/80 border border-white/10 object-cover" data-id="element-179" />
                </div>
              </FadeIn>
            </div>
          </div>
        </div>
      </div>
    </section>;
}